import React, {useEffect, useState} from 'react';
import Credit from './component/credit'
import tips from './image/tips.png'

function useWindowSize() {
  const getWindowSize = () => ({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
  })
  const [windowSize, setWindowSize] = useState(getWindowSize())
  const handleResize = () => {
      setWindowSize(getWindowSize())
  }
  useEffect(() => {
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
  })
  return windowSize
}


function App() {
  const [browserType, setBrowserType] = useState('');

  const clientSize = useWindowSize()
  useEffect(()=>{
    let ua = navigator.userAgent.toLocaleLowerCase()
    if (ua.match(/msie/) !=null || ua.match(/trident/) !=null) {
      setBrowserType('IE')
      console.log('browserType',browserType)
    }
    document.documentElement.style.fontSize = 10 * (clientSize.innerWidth / 960) + 'px';
  })

  return (
    <div id='app'>
      {
        (browserType==='IE')?
        <div className='tips-content'><img src={tips} alt='提示' className='tips'/></div>
        : <Credit />
      }
    </div>
  );
}

export default App;
